<template>
    <div>
        <p style="font-size:20px;font-weight:bold;">{{ title }}</p>
        <div class="ql-editor" v-html="content"></div>
    </div>
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

export default {
    created() {
        if(this.$route.query.code){
            this.share_code = this.$route.query.code;
            this.queryPainPoint();
        }else{
            this.$alert('分享码获取失败！', '错误', {
                confirmButtonText: '确定',
            });
        }
    },
    data() {
        return {
            share_code: '',
            title: '',
            content: '',
        }
    },
    methods: {
        queryPainPoint() {
            let params;
            params = {
                'share_code': this.share_code,
            }
            getdata.getListP("querySharedContent", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.title = resp.data.title;
                    this.content = resp.data.content;                  
                }else{
                    this.$alert(resp.data.message, '错误', {
                        confirmButtonText: '确定',
                    });
                }
            })
            .catch(err => {
                console.log(err);
            });
        }
    },
}
</script>

<style scoped>
.ql-editor {
  height: calc(100vh - 80px - 100px) !important;
}
</style>